﻿import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_COMPANIES_WITH_FOLLOW_STATUS,
  SEARCH_MANUFACTURES
} from "../../constant/Apipath";
import {
  Box,
  Card,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SearchField from "../common/SearchField";
import { BIBlue, BIRed } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddManufactureModal from "../common/AddManufactureModal";
import { useNavigate } from "react-router-dom";
import { setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import { AddButton } from "../common/AddButton";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import { CompaniesSkeleton } from "../skeleton/SkeletonView";
import VerifiedIcon from "@mui/icons-material/Verified";
import AdContainer from "../common/AdContainer";


const Manufactures = () => {
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Manufacturers || {};

  const {
    TEXT_MANUFACTURER_PROFILES = English.Manufacturers.TEXT_MANUFACTURER_PROFILES,
    TEXT_SEARCH_MANUFACTURERS = English.Manufacturers.TEXT_SEARCH_MANUFACTURERS,
    TEXT_RESULTS = English.Manufacturers.TEXT_RESULTS,
    NO_RESULT = English.Manufacturers.NO_RESULT,
    TEXT_ADD_MANUFACTURER = English.Manufacturers.TEXT_ADD_MANUFACTURER,
    BUTTON_REPORT = English.Manufacturers.BUTTON_REPORT
  } = LanguageData || {};

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [recordId, setRecordId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nrOfRecords, setNrOfRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNr, setPageNr] = useState(1);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const manufactureTabs = [
    { value: "all", label: "All Manufacturers" },
    { value: "following", label: "My Following" }
  ];
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (reportSuccess !== true) fetchData(searchTerm, 1, activeTab);
  }, [reportSuccess]);

  const fetchData = async (searchTerm, pageNo, tabValue = activeTab) => {
    try {
      if (pageNo === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);
      const isFollowingTab = tabValue === "following";
      const obj =
      //  isFollowingTab? 
          {
            UserId: currentUserId,
            SearchString: searchTerm ?? "",
            PageNumber: pageNo,
            PageSize: 25,
            Manufacturer: true,
            fetchFollowingRecordsOnly: true,
            FetchAllowedRecordsOnly: true,
            IsFollowing: isFollowingTab ? true : false
          }
        // : {
        //     UserId: currentUserId,
        //     SearchString: searchTerm,
        //     PageNumber: pageNo,
        //     NrRowsPerPage: 25,
        //     IncludeRecordNr: true,
        //     FullSearch: searchTerm ?? ""
        //   };
      const res = await Postrequestcall(
        FETCH_COMPANIES_WITH_FOLLOW_STATUS,
        // isFollowingTab ? FETCH_COMPANIES_WITH_FOLLOW_STATUS : SEARCH_MANUFACTURES,
        obj,
        loginData?.accessToken
      );
      const resData = res?.data?.data || [];
      setData((prevData) => (pageNo === 1 ? resData : [...prevData, ...resData]));
      setNrOfRecords(res?.data?.nrOfRecords || 0);
      setAllDataLoaded(false);
      setIsLoading(false);
    } catch (error) {
      console.error("fetchData-> Error fetching data: ", error);
      setAllDataLoaded(false);
      setIsLoading(false);
    } finally {
      setAllDataLoaded(false);
      setIsLoading(false);
    }
  };

  const getAddress = (item) => {
    const { address, city, province, postalCode, country } = item || {};
    return [address, city, province, postalCode, country].filter(Boolean).join(", ");
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    // Manual search only - user must click the search icon or press Enter
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    fetchData(searchTerm, 1, newValue);
  };

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => setMoreMenuAnchorEl(null);

  const handleLoadMore = async () => {
    if (data.length < nrOfRecords) {
      const nextPage = pageNr + 1;
      await fetchData(searchTerm, nextPage, activeTab);
      setPageNr(nextPage);
    }
  };
  const onManufactureClick = async (item) => {
    navigate(`/manufacture/${item?.id}`);
  };

  const handleViewReport = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.manufacturers?.name,
      AppScreenId: Pages?.manufacturers?.id,
      recordId: recordId.id ?? 0,
      isVerified: !!recordId?.verified
    };
    dispatch(setShowReport(reportObj));
  };

  const handleAddPostClick = (event) => {
    event.target.blur();
    setShowAddItemModal(true);
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_MANUFACTURER_PROFILES} />
      <Card className="main-content-card">
        <Grid sx={{ pb: 1.5,  display: "flex", alignItems: "center",  justifyContent: "space-between" }}  container spacing={1}>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 4 }}>
            <SearchField
              size={"small"}
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={() => fetchData(searchTerm, 1, activeTab)}
              onClear={() => {
                setSearchTerm("");
                setPageNr(1);
                fetchData("", 1, activeTab);
              }}
              searchIconOutside
              placeholder={TEXT_SEARCH_MANUFACTURERS}
            />
          </Grid>
          <Grid sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }} size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>
              {nrOfRecords} {TEXT_RESULTS}
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}>
            {manufactureTabs.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        {isLoading ? (
          <CompaniesSkeleton />
        ) : (
          <>
            <Box className="main-content-card-list" id="scrollablediv_prodcut">
              {data.length !== 0 ? (
                <InfiniteScroll
                  dataLength={data?.length}
                  next={handleLoadMore}
                  hasMore={data.length < nrOfRecords}
                  loader={
                    !allDataLoaded ? null : (
                      <h4 style={{ display: "flex", justifyContent: "center" }}>
                        <Loader />
                      </h4>
                    )
                  }
                  scrollableTarget="scrollablediv_prodcut">
                  <List disablePadding>
                    <Stack sx={{ gap: 1 }} >
                      {data?.map((item, index) => (
                        <Card
                          key={index}
                          onClick={() => {
                            onManufactureClick(item);
                          }}
                          className="pagelist-content">
                          <ListItem
                            key={index}
                            secondaryAction={
                              <IconButton
                                onClick={(event) => {
                                  handleMenuOpen(event, item);
                                  setRecordId(item);
                                }}>
                                <MoreIcon />
                              </IconButton>
                            }
                            disablePadding>
                            <ListItemButton>
                              <ListItemText
                                style={{ fontSize: "15px" }}
                                primary={
                                  <Stack sx={{ gap: 0.4 }} direction={'row'} >
                                    {item?.name}
                                    {item?.verified && (
                                      <VerifiedIcon
                                        sx={{
                                          color: BIBlue,
                                          fontSize: "1.2rem"
                                        }}
                                      />
                                    )}
                                  </Stack>
                                }
                                secondary={getAddress(item)}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      ))}
                    </Stack>
                  </List>
                </InfiniteScroll>
              ) : (
                <Box className="empty-data-card">
                  <Emptydata
                    icon={<BusinessCenterIcon className="emptydata-icon" />}
                    firstText={NO_RESULT}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
        <AddButton toolTipText={TEXT_ADD_MANUFACTURER} onAddClick={handleAddPostClick} />
        <AdContainer />
      </Card>

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem style={{ color: BIRed }} dense onClick={() => handleViewReport()}>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}

      {showAddItemModal && (
        <AddManufactureModal
          open={showAddItemModal}
          onClose={() => {
            setShowAddItemModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default Manufactures;

